import { distillationFor_2A_2B, distillationFor_HOT_2A_2B, overHeadConditions, towerData } from "./helper";

export const ionicInputFor2B = (formatedDate: string, elementForTwoB: any, isFromReport : boolean) => {
  let tempUnit;
  if(!isFromReport) {

    if (elementForTwoB.desalter.desalterTemperature_UOM === '°F' || elementForTwoB.desalter.desalterTemperature_UOM === 'F') tempUnit = 'F';
    else if (elementForTwoB.desalter.desalterTemperature_UOM === '°C' || elementForTwoB.desalter.desalterTemperature_UOM === 'C') tempUnit = 'C';
  }


    return {
      inputDate: formatedDate,
      simulationId : !isFromReport ? null : elementForTwoB.simulationId, 
      desalter: {
        crudeCharge: parseFloat(elementForTwoB.desalter.crudeCharge),
        crudeCharge_UOM: elementForTwoB.desalter.crudeCharge_UOM,
        crudeGravity: parseFloat(elementForTwoB.desalter.crudeGravity),
        washPercentageData: {
          washPercentage: parseFloat(elementForTwoB.desalter.washPercentageData.washPercentage),
          washPercentage2: parseFloat(elementForTwoB.desalter.washPercentageData.washPercentage2),
        },
        brineRecyclePercentage: parseFloat(elementForTwoB.desalter.brineRecyclePercentage ? elementForTwoB.desalter.brineRecyclePercentage : 0),
        percentageAtmH2OtoDesalter: parseFloat(elementForTwoB.desalter.percentageAtmH2OtoDesalter ? elementForTwoB.desalter.percentageAtmH2OtoDesalter : 0),
        percentageAtmH2OtoSWS: parseFloat(elementForTwoB.desalter.percentageAtmH2OtoSWS ? elementForTwoB.desalter.percentageAtmH2OtoSWS : 0),
        percentageSSWtoDesalter: parseFloat(elementForTwoB.desalter.percentageSSWtoDesalter ? elementForTwoB.desalter.percentageSSWtoDesalter : 0),
        desalterTemperature: parseFloat(elementForTwoB.desalter.desalterTemperature),
        desalterTemperature_UOM: !isFromReport ? tempUnit : elementForTwoB.desalter.desalterTemperature_UOM,
        brinepHData: {
          brinepH: parseFloat(elementForTwoB.desalter.brinepHData.brinepH),
          brinepH2: parseFloat(elementForTwoB.desalter.brinepHData.brinepH2),
        },
        brineSampleTemperature: parseFloat(elementForTwoB.desalter.brineSampleTemperature),
        desCrudeBSWData: {
          desCrudeBSW: parseFloat(elementForTwoB.desalter.desCrudeBSWData.desCrudeBSW ? elementForTwoB.desalter.desCrudeBSWData.desCrudeBSW : 0),
          desCrudeBSW2: parseFloat(elementForTwoB.desalter.desCrudeBSWData.desCrudeBSW2 ? elementForTwoB.desalter.desCrudeBSWData.desCrudeBSW2 : 0),
        },
      },
      towerData: towerData(elementForTwoB,'2B',false),
      overheadConditions: overHeadConditions(elementForTwoB,isFromReport, tempUnit),
      liquidAssayStreams: {
        isWetReflux: !isFromReport ? (elementForTwoB.liquidAssayStreams.isWetReflux === true || elementForTwoB.liquidAssayStreams.isWetReflux === 'TRUE' ? true : false) : elementForTwoB.liquidAssayStreams.isWetReflux ? true : false,
        hydrocarbonLiquidHot: {
          reflux: parseFloat(
            elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.reflux ? elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.reflux : 0),
          reflux_UOM: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.reflux_UOM,
          product: parseFloat(elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.product),
          product_UOM: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.product_UOM,
          gravity: parseFloat(elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.gravity),
          distillationType: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidHot.distillationType,
          distillation : distillationFor_HOT_2A_2B(elementForTwoB, isFromReport, tempUnit)
        },
        hydrocarbonLiquidCold: {
          reflux: parseFloat(
            elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.reflux ? elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.reflux : 0
          ),
          reflux_UOM: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.reflux_UOM,
          product: parseFloat(elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.product),
          product_UOM: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.product_UOM,
          gravity: parseFloat(elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.gravity),
          distillationType: elementForTwoB.liquidAssayStreams.hydrocarbonLiquidCold.distillationType,
          distillation : distillationFor_2A_2B(elementForTwoB, isFromReport, tempUnit),
        },
      },
      offGasData: {
        offGas: parseFloat(elementForTwoB.offGasData.offGas ? elementForTwoB.offGasData.offGas : 0),
        offGas_UOM: elementForTwoB.offGasData.offGas_UOM,
        H2: parseFloat(elementForTwoB.offGasData.H2 ? elementForTwoB.offGasData.H2 : 0),
        H2S: parseFloat(elementForTwoB.offGasData.H2S ? elementForTwoB.offGasData.H2S : 0),
        CO2: parseFloat(elementForTwoB.offGasData.CO2 ? elementForTwoB.offGasData.CO2 : 0),
        C1: parseFloat(elementForTwoB.offGasData.C1 ? elementForTwoB.offGasData.C1 : 0),
        C2: parseFloat(elementForTwoB.offGasData.C2 ? elementForTwoB.offGasData.C2 : 0),
        C3: parseFloat(elementForTwoB.offGasData.C3 ? elementForTwoB.offGasData.C3 : 0),
        iC4: parseFloat(elementForTwoB.offGasData.iC4 ? elementForTwoB.offGasData.iC4 : 0),
        nC4: parseFloat(elementForTwoB.offGasData.nC4 ? elementForTwoB.offGasData.nC4 : 0),
        iC5: parseFloat(elementForTwoB.offGasData.iC5 ? elementForTwoB.offGasData.iC5 : 0),
        nC5: parseFloat(elementForTwoB.offGasData.nC5 ? elementForTwoB.offGasData.nC5 : 0),
        nC6: parseFloat(elementForTwoB.offGasData.nC6 ? elementForTwoB.offGasData.nC6 : 0),
      },
      overheadWater: {
        combinedRefluxData :{
          combinedRefluxFlow: parseFloat(elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxFlow ? elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxFlow  : 0),
          combinedRefluxTemp : parseFloat(elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxTemp ? elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxTemp  : 0),
          combinedRefluxFlow_UOM: elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxFlow_UOM,
          combinedRefluxTemp_UOM : !isFromReport ? tempUnit : elementForTwoB.overheadWater.combinedRefluxData.combinedRefluxTemp_UOM,
        },
        pHData: {
          pH: parseFloat(elementForTwoB.overheadWater.pHData.pH),
          pH_2: parseFloat(elementForTwoB.overheadWater.pHData.pH_2),
        },
        clData: {
          cl: parseFloat(elementForTwoB.overheadWater.clData.cl ? elementForTwoB.overheadWater.clData.cl : 0),
          cl_2: parseFloat(elementForTwoB.overheadWater.clData.cl_2 ? elementForTwoB.overheadWater.clData.cl_2 : 0),
        },
        bromideData: {
          bromide: parseFloat(elementForTwoB.overheadWater.bromideData.bromide ? elementForTwoB.overheadWater.bromideData.bromide : 0),
          bromide_2: parseFloat(elementForTwoB.overheadWater.bromideData.bromide_2 ? elementForTwoB.overheadWater.bromideData.bromide_2 : 0)
        },
        NH3Data: {
          NH3: parseFloat(elementForTwoB.overheadWater.NH3Data.NH3 ? elementForTwoB.overheadWater.NH3Data.NH3 : 0),
          NH3_2: parseFloat(elementForTwoB.overheadWater.NH3Data.NH3_2 ? elementForTwoB.overheadWater.NH3Data.NH3_2 : 0),
        },
        neutralizerName: elementForTwoB.overheadWater.neutralizerName,
        neutralizerRate: parseFloat(elementForTwoB.overheadWater.neutralizerRate ? elementForTwoB.overheadWater.neutralizerRate : 0),
        neutralizerRate_UOM: elementForTwoB.overheadWater.neutralizerRate_UOM,
        outsideNeutralizer: parseFloat(elementForTwoB.overheadWater.outsideNeutralizer ? elementForTwoB.overheadWater.outsideNeutralizer : 0),
        outsideNeutralizer_UOM: elementForTwoB.overheadWater.outsideNeutralizer_UOM,
        trampAmineData: {
          trampAmine: elementForTwoB.overheadWater.trampAmineData.trampAmine,
          trampAmineppm: parseFloat(
            elementForTwoB.overheadWater.trampAmineData.trampAmineppm ? elementForTwoB.overheadWater.trampAmineData.trampAmineppm : 0
          ),
          trampAmineppm2: parseFloat(
            elementForTwoB.overheadWater.trampAmineData.trampAmineppm2 ? elementForTwoB.overheadWater.trampAmineData.trampAmineppm2 : 0
          ),
        },
        steamAmineData: {
          steamAmine: elementForTwoB.overheadWater.steamAmineData.steamAmine,
          steamAmineppm: parseFloat(
            elementForTwoB.overheadWater.steamAmineData.steamAmineppm ? elementForTwoB.overheadWater.steamAmineData.steamAmineppm : 0
          ),
          steamAmineppm2: parseFloat(
            elementForTwoB.overheadWater.steamAmineData.steamAmineppm2 ? elementForTwoB.overheadWater.steamAmineData.steamAmineppm2 : 0
          ),
        },
        overHeadWaterFlowData:{
          overHeadWaterFlow:parseFloat(elementForTwoB.overheadWater.overHeadWaterFlowData.overHeadWaterFlow >=0 ? elementForTwoB.overheadWater.overHeadWaterFlowData.overHeadWaterFlow : null),
          overHeadWaterFlowUOM:elementForTwoB.overheadWater.overHeadWaterFlowData.overHeadWaterFlowUOM,
          overHeadWaterFlow2:parseFloat(elementForTwoB.overheadWater.overHeadWaterFlowData.overHeadWaterFlow2 >=0 ? elementForTwoB.overheadWater.overHeadWaterFlowData.overHeadWaterFlow2 : null)
        }
      },
    };
  };
  